import {Box, Typography} from "@mui/material"
import {useContext} from "react"
import {AppDataContext} from "../../App"

export const TabMode = {
    Main: "main",
    Docs: "docs",
}

const styles = {
    root: {

    },
    tab: {
        padding: '1rem 8px',
        height: '160px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        writingMode: 'vertical-lr',
        cursor: "pointer",
    },
    tabText: {
        color: "white",
        fontWeight: "bold",
    },
}

const LeftTabView = () => {

    const { state, setTabMode } = useContext(AppDataContext)

    return (
        <Box style={styles.root}>
            <Box style={{...styles.tab, background: state.tabMode === TabMode.Main ? "#004A92" : "#8EA0B3"}} onClick={() => setTabMode(TabMode.Main)}><Typography style={styles.tabText}>地図表示</Typography></Box>
            <Box style={{...styles.tab, background: state.tabMode === TabMode.Docs ? "#004A92" : "#8EA0B3"}} onClick={() => setTabMode(TabMode.Docs)}><Typography style={styles.tabText}>集約・文書検索</Typography></Box>
        </Box>
    )

}

export default LeftTabView
